<template>
    <BaseModal
        :id="'confirmation-fields-modal'"
        :title="title"
        :message="`You're making updates to various associates. Please specify if you wish to update the following fields, as they can be left empty.`"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-md-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                  :form_format="form_format"
                  :form_data="form_data"
                  :array_options="[]"
                  :for_update="false"
                  :content_align_x="'no-justify'"
                />
                <div v-if="form_data.room_type_id">
                    <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray;">
                        <span><img src="/assets/img/svg/information.svg" alt="CustomDescription" style="width: 15px;"></span>
                        <span style="margin-left: 5px;">As you want to edit the room type, confirm the data to update according to the room type</span>
                    </h6>
                    
                    <div class="p-0 formdynamic__item col-md-12" style="margin-top: 0px;">
                        <div class="formdynamic__item__field">
                            <label for="Default daily task:" class="modal-label">Default daily task: </label>
                            <span class="custom-control custom-checkbox">
                                <input id="ref0def_daily_task" type="checkbox" class="custom-control-input" value="default_daily_task" v-model="form_data.confirmation_fields">
                                <label for="ref0def_daily_task" class="custom-control-label ml-2"></label>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button class="modal__buttons__item" v-html="`Confirm`"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<style scoped>
    .black-label{
        color:black;
    }
</style>

<script>

import FormResources from './form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'

export default {
  name: "FieldsConfirmationModal",

    props: [
        "title",
        "notyf",
        "breadcrumb",
        "form_data"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
    },

    data(){
        return{
            form_format: FormResources.confirmation_form_format,
        }
    },

    methods: {

        form_submit()
        {  
            this.$emit('formSubmit', true)
        },

    },

  mounted() {},

};
</script>